import type { IListingRating, IReservation, IUser } from '@curbnturf/objects';
import { generateReservationConfirmationCode } from './reservation';

export const generateRatingPrivateNote = function (rating: IListingRating): string {
  if (!rating?.reservation) {
    return '';
  }

  return `For rating ${generateReservationConfirmationCode(rating.reservation)}`;
};

export const generateReservationPrivateNote = function (reservation: IReservation): string {
  return `Rent for ${generateReservationConfirmationCode(reservation)}`;
};

export const generateReservationChangeIncreasePrivateNote = function (reservation: IReservation): string {
  return `Rent increase for ${generateReservationConfirmationCode(reservation)}`;
};

export const generateReferralPrivateNote = function (reservation: IReservation): string {
  return `Referral credit for ${generateReservationConfirmationCode(reservation)}`;
};

export const generateBoondockDonationPrivateNote = function (donation: {
  user: IUser;
  boondockName: string;
  boondockId: number;
  price: number;
}): string {
  return `Boondocking donation for: ${donation.boondockName}(${donation.boondockId})`;
};

export const generatePoiDonationPrivateNote = function (donation: {
  user: IUser;
  poiName: string;
  poiId: number;
  price: number;
}): string {
  return `Point of Interest donation for: ${donation.poiName || 'Unnamed'}(${donation.poiId})`;
};

export const generateReservationCntPayment = function (reservation: IReservation): string {
  return `CNT Cash used for a reservation: ${generateReservationPrivateNote(reservation)}`;
};

export const generateDonationCntPayment = function (purchaseId: string): string {
  return `CNT Cash used for a donation: ${purchaseId}`;
};
